var _defs, _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHangerEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hanger",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    stroke: "currentColor",
    d: "M-82.71,135H233.71v37.341H-82.71V135Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    x: 10,
    y: 10,
    width: 6,
    height: 133
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    x: 16,
    y: 10,
    width: 117,
    height: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    x: 74,
    y: 16,
    width: 2,
    height: 18
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerEmpty);
export default __webpack_public_path__ + "static/media/hanger-empty.27d8f4fd56971ffa8232ba61db5474aa.svg";
export { ForwardRef as ReactComponent };